import { render } from "./ProjectInfo.vue?vue&type=template&id=9decfe7e&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=9decfe7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9decfe7e"]])

export default __exports__